import { defineView } from "foldkit/submodel";

import { i18next } from "../../i18n";

import type { Shared } from "../shared";
import { Message } from "./message";
import type { Model } from "./model";

const t = (key: string): string => i18next.t(`developers.${key}`);

/** The library name is not translated; the in-house input's label is. */
const options = (): ReadonlyArray<readonly [string, string]> => [
	["external", "react-tag-autocomplete"],
	["internal", t("daisyTagInput")],
];

export const view = defineView<Model, Message, Shared>((model, _shared, h) =>
	h.div(
		[h.DataAttribute("testid", "page-Developers"), h.Class("space-y-6")],
		[
			h.h1([h.Class("text-lg font-bold")], [t("title")]),
			h.div(
				[h.Class("space-y-4")],
				[
					h.section(
						[
							h.Class(
								"rounded-2xl border border-base-300 bg-base-100 p-4 space-y-2",
							),
						],
						[
							h.div(
								[h.Class("flex items-center justify-between")],
								[
									h.label(
										[
											h.Class("label-text font-medium"),
											h.For("tag-input-mode"),
										],
										[t("tagInputMode")],
									),
									h.span([h.Class("badge badge-ghost")], [t("beta")]),
								],
							),
							h.select(
								[
									h.Id("tag-input-mode"),
									h.Class("select select-bordered w-full max-w-xs"),
									h.AriaLabel(t("tagInputMode")),
									h.Value(model.tagInputVariant),
									h.OnChange((value) =>
										Message.SelectedVariant({
											variant: value === "internal" ? "internal" : "external",
										}),
									),
								],
								options().map(([value, label]) =>
									h.option(
										[
											h.Value(value),
											h.Selected(model.tagInputVariant === value),
										],
										[label],
									),
								),
							),
							h.p(
								[h.Class("text-sm text-base-content/70 max-w-xl")],
								[t("tagInputHelp")],
							),
						],
					),
				],
			),
		],
	),
);
